export const createInitialContext = (identifier) => ({
  anchors: identifier ? [{ type: 'qr', identifier }] : [],
  location: null,
});

export const addLocationToContext = (context, coords) => ({
  ...context,
  location: {
    latitude: coords.latitude,
    longitude: coords.longitude,
    accuracyMeters: coords.accuracy,
  },
});

export const addResolvedAnchor = (context, anchor) => ({
  ...context,
  anchors: [
    ...context.anchors.filter((current) => current.type !== anchor.type),
    anchor,
  ],
});
